import React from 'react';
import { T } from 'shared/helper/translate';
var DigitalOrdersAlert = function DigitalOrdersAlert(_ref) {
  var digitalOrdersLinkTerm = _ref.digitalOrdersLinkTerm;
  return digitalOrdersLinkTerm ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-block alert-warning"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: digitalOrdersLinkTerm
  })))) : null;
};
export default DigitalOrdersAlert;